var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowOpenRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5.718,
    height: 10,
    viewBox: "0 0 5.718 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow_open_right",
    d: "M4,5L0.2,8.8c-0.3,0.3-0.3,0.7,0,1c0,0,0,0,0,0c0.3,0.3,0.7,0.3,1,0l4.3-4.3c0.3-0.3,0.3-0.7,0-1L1.2,0.2c-0.3-0.3-0.7-0.3-1,0C0,0.5,0,0.9,0.2,1.2L4,5z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowOpenRight);
export default __webpack_public_path__ + "static/media/arrow_open_right.3aa0293695d549a276726a1d264bd635.svg";
export { ForwardRef as ReactComponent };